import { Text } from '@mantine/core'
import React, { type PropsWithChildren } from 'react'

import classes from './styles.module.css'

export function Description({ children }: PropsWithChildren) {
  return (
    <Text className={classes.description} color='dimmed'>
      {children}
    </Text>
  )
}
